"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M8 8a4 4 0 1 1 8 0v.5a.5.5 0 0 0 .5.5h1a3.5 3.5 0 1 1 0 7h-3a.5.5 0 0 0 0 1h3a4.5 4.5 0 1 0 0-9H17A5 5 0 0 0 7 8h-.5a4.5 4.5 0 1 0 0 9h3a.5.5 0 0 0 0-1h-3a3.5 3.5 0 1 1 0-7h1a.5.5 0 0 0 .5-.5z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12.5 11.5a.5.5 0 0 0-1 0v9.793l-2.646-2.647a.5.5 0 0 0-.708.708l3.5 3.5a.5.5 0 0 0 .708 0l3.5-3.5a.5.5 0 0 0-.708-.708L12.5 21.293z"
  })]
}), 'DownloadCloud');
//# sourceMappingURL=index.js.map